import React from "react";
import { StyledSvgIcon } from "../icon.styles";
import { customIconsPropTypes } from './customicons.propTypes';

const AutoRepairIcon = ({
  fontSize,
  color,
  backgroundColor,
  title,
  backgroundShape,
  theme,
}) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
  >
    <svg
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.0415 18.5315C26.056 18.3105 26.0995 18.0894 26.0995 17.8684V18.6052L26.0415 18.5315ZM11.5998 17.8684C11.5998 18.9146 11.8173 19.9166 12.2088 20.8154H4.34992V22.2889C4.34992 23.0993 3.69743 23.7624 2.89995 23.7624H1.44997C0.652488 23.7624 0 23.0993 0 22.2889V10.501L3.01594 1.66001C3.30594 0.805389 4.11792 0.186523 5.0749 0.186523H21.0246C21.9816 0.186523 22.7936 0.805389 23.0836 1.66001L26.0995 10.501V17.8684C26.0995 13.8016 22.8516 10.501 18.8496 10.501C14.8477 10.501 11.5998 13.8016 11.5998 17.8684ZM7.24986 14.1847C7.24986 12.9617 6.27838 11.9744 5.0749 11.9744C3.87143 11.9744 2.89995 12.9617 2.89995 14.1847C2.89995 15.4077 3.87143 16.3949 5.0749 16.3949C6.27838 16.3949 7.24986 15.4077 7.24986 14.1847ZM23.1996 9.02746L21.0246 2.39676H5.0749L2.89995 9.02746H23.1996ZM28.811 25.5158L22.8516 19.4598C23.4461 17.9273 23.1126 16.1297 21.8656 14.8772C20.5606 13.5363 18.6031 13.2711 17.0227 14.0079L19.8356 16.8664L17.8782 18.8704L14.9927 15.9971C14.2097 17.6032 14.5722 19.5924 15.8482 20.9333C16.4241 21.5302 17.1591 21.9431 17.9628 22.1212C18.7666 22.2992 19.604 22.2346 20.3721 21.9352L26.3315 27.9766C26.5925 28.2565 26.984 28.2565 27.245 27.9766L28.753 26.4589C29.072 26.1936 29.072 25.7221 28.811 25.5158Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);

export default AutoRepairIcon;
AutoRepairIcon.propTypes = customIconsPropTypes;
